import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';

export default class TiltExample extends Phaser.GameObjects.Image {
  /**
   * 
   * @param {Phaser.Scene} scene 
   */
  constructor(scene) {
    super(scene, 0, 0, ABCyaPhaser.Images.DEFAULT_ATLAS, 'ExampleTablet');
  }
}